export default __webpack_public_path__ + "static/media/m-fsk-04.0e49759a.jpg";